import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseFunctionalitiesSet = (store: StoreSchema) => store.license.cachedLicense.functionalitiesSet